export default __webpack_public_path__ + "static/media/Akramul_Software_Engineer.10fa335b.pdf";